function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0v3.6h11.9c.6 0 1.2.3 1.7.7.5.5.7 1.1.7 1.7v12c0 1.3-1.1 2.4-2.4 2.4H6c-1.3 0-2.4-1.1-2.4-2.4V6c0-1.3 1.1-2.4 2.4-2.4V0zm0 0C2.7 0 0 2.7 0 6v12c0 3.3 2.7 6 6 6h11.9c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6H6c.1 0 0 0 0 0z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;